module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones_tablet_de@2x-878206ffc6ca482f19a0fe5d7a569755.png";